function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PureComponent } from 'react';
import { canUseDOM, canUseEventListeners } from 'exenv';
import PropTypes from 'prop-types';
/**
 * Components can delegates to EventListener the listening of specific elements
 * and trigger callback if the specified events have been triggered to these elements
 * Comes handy to handle outside clicks for example.
 *
 * @param {Array} listeners - array of object { target: string, event: string, handler: fn, options: boolean }
 * e.g. { target: 'document', event: 'click', handler: () => { ... },  options: true }
 *
 * @return null
 */

var EventListener = /*#__PURE__*/function (_PureComponent) {
  _inherits(EventListener, _PureComponent);

  var _super = _createSuper(EventListener);

  function EventListener() {
    var _this;

    _classCallCheck(this, EventListener);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getTargetNode", function (target) {
      if (canUseDOM) {
        return global[target] || global.document.querySelector(target);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addEventListeners", function (listeners) {
      if (canUseEventListeners) {
        listeners.forEach(function (_ref) {
          var target = _ref.target,
              event = _ref.event,
              handler = _ref.handler,
              options = _ref.options;

          var node = _this.getTargetNode(target);

          node && node.addEventListener(event, handler, options);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeEventListeners", function (listeners) {
      if (canUseEventListeners) {
        listeners.forEach(function (_ref2) {
          var target = _ref2.target,
              event = _ref2.event,
              handler = _ref2.handler,
              options = _ref2.options;

          var node = _this.getTargetNode(target);

          node && node.removeEventListener(event, handler, options);
        });
      }
    });

    return _this;
  }

  _createClass(EventListener, [{
    key: "componentDidMount",
    value:
    /**
     * componentDidMount - lifeycle method
     * Adds event listeners on mount
     *
     */
    function componentDidMount() {
      var listeners = this.props.listeners;
      this.addEventListeners(listeners);
    }
    /**
     * componentDidUpdate - lifeycle method
     * Update event listeners
     *
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var listeners = this.props.listeners;
      this.removeEventListeners(prevProps.listeners);
      this.addEventListeners(listeners);
    }
    /**
     * componentWillUnmount - lifeycle method
     * Update event listeners
     *
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var listeners = this.props.listeners;
      this.removeEventListeners(listeners);
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return EventListener;
}(PureComponent);
/**
 * PropTypes Validation.
 */


var array = PropTypes.array;
EventListener.propTypes = {
  listeners: array.isRequired
};
EventListener.displayName = 'EventListener';
export default EventListener;